import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Container, DialogActions,
	DialogContentText, MenuItem, Paper,
	Tooltip,
	Typography
} from "@mui/material";
import Grid from "@mui/material/Grid";
import {useForm, FormProvider} from "react-hook-form";
import Button from "@mui/material/Button";
import SimpleDialog from "../../../widgets/dialogs/SimpleDialog";
import clsx from "clsx";
import HideAppBar from "../../../widgets/header/HideAppBar";
import FileInput from "../../carico/utils/FileInput";
import {InternalTicketDetails} from "../details/InternalTicketDetails";
import SearchPaper from "../../paziente/utils/SearchPaper";
import SearchCardResult from "../../paziente/utils/SearchCardResult";
import {AnagraficaCompleta} from "../../../widgets/common/AnagraficaCompleta";
import useAnagraficaSearch from "../../paziente/utils/useAnagraficaSearch";
import {searchAnagrafica} from "../../../../services/AnagraficaServices";
import {clean, getAccountInfo} from "../../../../utils/GenericUtils";
import {AnagraficaContext, AppContext, TicketContext} from "../../../../App";
import {resetAnagrafica} from "../../interviste/intervista/utils/ResetUtils";
import CustomSelect from "../../../widgets/inputs/CustomSelect";
import {spAslCode} from "../../../../utils/dictionaries/Generics";
import {getTicketData} from "../../../../services/utils/TicketApiData";
import {generateTicket, resetAddTicket} from "../../../../services/TicketServices";
import {setOpenSnackbar} from "../../../../services/AppServices";


const CreaTicket = () => {
	const classes = BaseStyle();
	const appContext = useContext(AppContext);
	const anagraficaContext = useContext(AnagraficaContext);
	const ticketContext = useContext(TicketContext);
	const methods = useForm({mode: "onChange"});
	const [info, setInfo] = useState(false);
	const [value, setInputValue] = useState("");
	const [open, setOpen] = useState(false);
	const [pageNumber, setPageNumber] = useState(0);
	const [tags, setTags] = useState([]);
	const {loadingSearch, errorSearch, anagraficheSearch, hasMoreSearch} = useAnagraficaSearch(value, pageNumber, false);
	const observer = useRef();
	const [anagraficaSelected, setAnagraficaSelected] = useState({});
	const [submit, setSubmit] = useState(false);
	
	const lastTicketElementRef = useCallback(node => {
		if (loadingSearch) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMoreSearch) {
				setPageNumber(prevState => prevState + 1);
			}
		})
		if (node) observer.current.observe(node)
	}, [loadingSearch, hasMoreSearch])
	
	const handleSearch = (event) => {
		setInputValue(event.target.value);
	}
	
	const onSearch = useCallback(() => {
		if (open) {
			let data = methods.getValues()?.["search"]
			searchAnagrafica(clean(data), anagraficaContext.dispatch);
		}
	}, [methods, open, anagraficaContext.dispatch])
	
	const onSubmit = useCallback((data) => {
		console.log(getAccountInfo().roles);
		setSubmit(true);
		let src = "SP_301";
		getAccountInfo().roles?.forEach(role => {
			if (spAslCode[role.replaceAll("ROLE_")]) {
				src = spAslCode[role.replaceAll("ROLE_")];
			}
		})
		let ticket = getTicketData(data, data.stato, [], tags, "INT", 0, false, src)
		console.log(ticket);
		generateTicket(ticket, ticketContext.dispatch)
	}, [tags, ticketContext.dispatch]);
	
	const handleKeyDown = useCallback((event) => {
		if (event.ctrlKey && event.keyCode === 13) {
			methods.trigger().then(res => {
				if (res) {
					onSubmit(methods.getValues())
				}
			});
		}
	}, [methods, onSubmit])
	
	const onClickDetail = (anagrafica) => {
		setAnagraficaSelected(anagrafica);
		let value = resetAnagrafica(anagrafica);
		methods.reset(value);
	}
	
	useEffect(() => {
		if (submit && !ticketContext.state.loadingAddTicket && ticketContext.state.errorAddTicket === "") {
			setOpenSnackbar("success", "Ticket registrato con successo!", appContext.dispatch);
			setSubmit(false);
			resetAddTicket(ticketContext.dispatch);
			methods.reset({});
			methods.setValue("dettaglioRichiesta", "");
			setTags([]);
		} else if (submit && !ticketContext.state.loadingAddTicket && ticketContext.state.errorAddTicket !== "") {
			setOpenSnackbar("error", ticketContext.state.errorAddTicket, appContext.dispatch);
			setSubmit(false);
		}
	}, [appContext.dispatch, ticketContext.state.loadingAddTicket, ticketContext.state.errorAddTicket, ticketContext.dispatch, submit, methods])
	
	useEffect(() => {
		document.body.style = "background: none";
	}, []);
	
	return (
		<React.Fragment>
			<main className={classes.main}>
				<HideAppBar title={"Crea ticket"} back={true} backPosition={"/gestione/tickets"} home={"/gestione"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<FormProvider {...methods}>
						<Grid container spacing={3}>
							<SearchPaper value={value} open={open} onSearch={onSearch} handleSearch={handleSearch}
							             setOpen={setOpen}/>
							
							<Grid item xs={12}>
								<SearchCardResult open={open} onClickDetail={onClickDetail} anagraficheSearch={anagraficheSearch}
								                  errorSearch={errorSearch} loadingSearch={loadingSearch}
								                  lastTicketElementRef={lastTicketElementRef} color={true}/>
							</Grid>
							
							<Grid item xs={12}>
								<Paper className={clsx(classes.roundPaper, classes.padding2)}>
									<Grid container spacing={3}>
										<AnagraficaCompleta classes={classes} intro={"false"} moreInfo={true}
										                    anagrafica={anagraficaSelected}/>
									</Grid>
								</Paper>
							</Grid>
							
							<Grid item xs={12}>
								<Card className={clsx(classes.roundBorder, classes.transparent80)}
								      style={{height: "100%", display: "flex", flexDirection: "column"}}>
									<CardHeader
										title={<Typography variant={"h6"}><b>Dettaglio ticket</b></Typography>}
										subheader={"Indica la categoria di appartenenza del ticket e la destinazione dello stesso."}
									/>
									<CardContent style={{flexGrow: 1}}>
										<Grid container spacing={3}>
											<InternalTicketDetails handleKeyDown={handleKeyDown} mail={true} tags={tags} setTags={setTags}/>
											<Grid item xs={12} sm={8}>
												<CustomSelect
													name={"dst"}
													label={"Destinazione"}
													control={methods.control}
													defaultValue={""}
													autoFocus={false}
													none={true}
													noneValue={""}
													rules={{required: false}}
													error={methods.errors["dst"]}
												>
													{Object.entries(spAslCode).map(([key, val]) => {
														return (
															<MenuItem value={key} key={key}>
																{val}
															</MenuItem>
														);
													})}
													<MenuItem value={"CIT"}>
														Cittadino
													</MenuItem>
												</CustomSelect>
											</Grid>
											<Grid item xs={12} sm={4} style={{display: "flex", alignItems: "center"}}>
												<CustomSelect
													name={"stato"}
													label={"Stato del ticket"}
													control={methods.control}
													defaultValue={"Risolto"}
													autoFocus={false}
													rules={{required: true}}
													error={methods.errors["stato"]}
												>
													<MenuItem value={"Risolto"}>
														Risolto
													</MenuItem>
													<MenuItem value={"In attesa"}>
														In attesa di risposta
													</MenuItem>
												</CustomSelect>
											</Grid>
											<Grid item xs={12}>
												<FileInput name={"allegato"} multiple={true} accept={"*"}/>
											</Grid>
										</Grid>
									</CardContent>
									<CardActions className={classes.flexRight}>
										<Tooltip title={"Alcune informazioni sulla gestione della destinazione e sul ticket in generale"}>
											<Button variant={"text"} disableElevation size={"small"}
											        style={{borderRadius: 24}}
											        className={classes.roundButton} onClick={() => setInfo(!info)}>
												<b>informazioni sul ticket interno</b>
											</Button>
										</Tooltip>
										<Tooltip title={"Conferma i dati inseriti sopra "}>
											<Button variant={"contained"} disableElevation color="primary" size={"small"}
											        style={{borderRadius: 24}}
											        className={classes.roundButton} onClick={methods.handleSubmit(onSubmit)}>
												<b>Conferma ed invia</b>
											</Button>
										</Tooltip>
									</CardActions>
								</Card>
							</Grid>
							
							{
								info && <SimpleDialog open={info} maxWidth={"md"} title={"Informazioni sul ticket"}
								                      handleClose={() => setInfo(false)}
								                      content={<DialogContentText>
									                      <b>Cos'è un ticket interno?</b><br/>
									                      Un ticket interno (questo per intenderci) è un ticket a tutti gli effetti in cui
									                      il tipo di ticket è settato ad "Interno" (le alternative sono Ticket Form o
									                      Callcenter) e in cui puoi decidere la destinazione del ticket.
									                      <br/>
									                      <br/>
									                      <b>Quali sono le destinazioni possibili del ticket?</b><br/>
									                      Tra le scelte avrai a disposizione tutte le Asl, noi programmatori dell ICT ed
									                      il cittadino. Scegliendo cittadino indichi a chi visualizzerà e gestirà il
									                      ticket che è destinato al cittadino, tuttavia rimarrà sempre categorizzato come
									                      tipo "Interno".
									                      <br/>
									                      <br/>
									                      <b>Devo inserire i miei dati nell'anagrafica?</b><br/>
									                      Dipende. Nell'anagrafica devi inserire i dati del paziente per il quale
									                      necessiti aprire un ticket. Se Mario Rossi è il paziente per cui devi comunicare
									                      informazioni ad un'altra Asl allora inserirai l'anagrafica di Mario
									                      Rossi; se il cittadino per cui apri il ticket è Giuseppe Verdi allora inserirai
									                      l'anagrafica di Giuseppe Verdi e così via.<br/><br/>
								                      </DialogContentText>} actions={
									<DialogActions>
										<Button onClick={() => setInfo(false)} size="small" disableElevation
										        variant={"contained"} style={{borderRadius: 24}}
										        className={classes.roundButton} color={"primary"} autoFocus>
											<b>Ok, chiudi</b>
										</Button>
									</DialogActions>}/>
							}
						
						</Grid>
					</FormProvider>
				</Container>
			</main>
		</React.Fragment>
	);
};

export default React.memo(CreaTicket);
